import { render, staticRenderFns } from "./UploaderFile.vue?vue&type=template&id=2fbdff5e&scoped=true"
import script from "./UploaderFile.vue?vue&type=script&lang=js"
export * from "./UploaderFile.vue?vue&type=script&lang=js"
import style0 from "./UploaderFile.vue?vue&type=style&index=0&id=2fbdff5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbdff5e",
  null
  
)

export default component.exports